<template>
  <component
    v-if="name && customIcon"
    :is="customIcon"
    :class="props.size"
    stroke="currentColor"
  />
</template>

<script setup lang="ts">
import icons from './icons'

interface Props {
  name?: string
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'h-5 w-5'
})

const customIcon = defineAsyncComponent(async () => {
  try {
    return await import(`@/assets/images/icons/outline/${props.name || 'calendar-days'}.svg`)
  } catch (error) {
    console.log(error)
    return await import(`@/assets/images/icons/outline/home.svg`)
  }
})
</script>
  